import React from 'react'
import JoditEditor from "jodit-react";
import NavigationButtons from '../../../components/NavigationButtons';

const EmailTemplates = () => {
    const config = {
        readonly: false, 
        height: 380,
        toolbar: true, 
        showCharsCounter: false, 
        showWordsCounter: false, 
        showXPathInStatusBar: false, 
        showResizer: false, 
        statusbar: false, 
        buttons: ["bold", "italic", "underline", "ul", "ol", "align", "font"], 
        buttonsMD: ["bold", "italic", "underline", "ul", "ol", "align", "font"], 
        buttonsSM: ["bold", "italic", "underline", "ul", "ol", "align", "font"], 
        buttonsXS: ["bold", "italic", "underline", "ul", "ol", "align", "font"], // Font family added for XS screens
      };
  return (
    <div className='p-8 mt-8 space-y-4 '>
    <div className='flex  gap-4 '>
        <div className='h-[475px] w-[30%] border rounded-md flex flex-col items-center p-2 text-gray-500'>
            <div type="text" name="" id="" className='w-[90%] border rounded-md flex items-center justify-between p-2'>
                <p> Template Name</p>
                <div className='w-[30px] h-[30px] bg-[#FF9348] text-center rounded-md text-white font-medium cursor-pointer '>+</div>
            </div>
            <div type="text" name="" id="" className='w-[90%] border-b-2 p-2'>Example Template</div>
            <div type="text" name="" id="" className='w-[90%] border-b-2 p-2'>Example Template</div>

            <div type="text" name="" id="" className='w-[90%] border-b-2 p-2'>Example Template</div>

            <div type="text" name="" id="" className='w-[90%] border-b-2 p-2'>Example Template</div>
        </div>
        <div className="container mx-auto h-auto gap-2">
      {/* Subject Input */}
      {/* <div className="flex flex-col">
        <label htmlFor="subject" className="text-2xl font-bold mb-4">Subject</label>
        <input
          id="subject"
          type="text"
        //   value={subject}
        //   onChange={(e) => setSubject(e.target.value)}
          className="border-4 border-double h-[50px] rounded-md mb-2 outline-none p-2"
          placeholder="Enter Subject....."
        />
      </div> */}

      {/* Email Body */}
      <div className="mx-auto rounded-lg border border-gray-300 shadow-lg p-2 space-y-4 relative ">
      <h1 className=" font-bold mb-4 absolute bg-white p-2 top-[-25px]">Template</h1>
        <JoditEditor
        //   ref={editorRef}
          config={config}
        //   value={body}
        //   onBlur={handleContentChange}
        //   onChange={handleContentChange}
        />

        {/* Dynamic Tags */}
        {/* <div className="flex flex-wrap mt-2">
          {tags?.map((tag) => (
            <div key={tag} className="relative">
              <button
                // onClick={() => handleCopy(tag)}
              >
                <span>{tag}</span>
              </button>
              {copiedTag === tag && (
                <span className="absolute bottom-8 left-16 bg-black text-white text-xs px-2 py-1 rounded">Copied!</span>
              )}
            </div>
          ))}
        </div> */}

        {/* Action Buttons */}
        <div className="flex justify-center items-center flex-row ">
          <div className="flex gap-4 m">
            <button onClick={() => window.history.back()} className="bg-gray-100 px-4 py-2 rounded-full text-gray-600 border border-gray-700 ">
             Close Template
            </button>
            <button 
            // disabled={loading} 
            // onClick={UpdateTemplate}
             className="bg-blue-500 text-white px-4 py-2 rounded-full hover:bg-blue-600">
            Save Template
            </button>
          </div>
        </div>
      </div>

      {/* Custom Styles for Jodit Editor */}
      <style jsx>{`
        .jodit-editor ul, ol {
          list-style-position: inside;
        }
        ul {
          list-style-position: inside;
          }
          `}</style>
    </div>
    </div>
          <NavigationButtons/>
    </div>
  )
}

export default EmailTemplates